import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { IconButton, Paper, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { MutableRefObject, ReactNode, useState } from 'react';

import { Loader } from '..';

import styles from './ExpandableCard.module.scss';


interface ExpandableCardProps {
    children: ReactNode;
    className?: string;
    classNames?: {
        expandedRow?: string;
    };
    indentContent?: boolean;
    expandedContent: ReactNode;
    nodeRef?: MutableRefObject<HTMLDivElement | null>;
    loading?: boolean;
}

export function ExpandableCard({
    children, className, expandedContent, classNames, nodeRef, loading, indentContent
}: ExpandableCardProps) {
    const [ expanded, setExpanded ] = useState(false);

    return (
        <Paper
            ref={nodeRef}
            variant="outlined"
            className={className}
        >
            <div className={styles.mainRow}>
                <Tooltip title={`${expanded ? 'Hide' : 'Show'} details`}>
                    <IconButton onClick={() => setExpanded(!expanded)}>
                        {expanded ? (
                            <ExpandLess color="secondary" />
                        ) : (
                            <ExpandMore color="secondary" />
                        )}
                    </IconButton>
                </Tooltip>

                {children}
            </div>

            <Loader
                className={styles.loader}
                loading={loading && expanded}
            />

            {!loading && expanded && (
                <div
                    className={clsx(styles.expandedRow, classNames?.expandedRow, {
                        [styles.indent]: indentContent
                    })}
                >
                    {expandedContent}
                </div>
            )}
        </Paper>
    );
}
